import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import Common from "./common/reducer";
import ticketReducer from "./ticket/ticketReducer";
import dashboardReducer from "./dashboard/dashboardReducer";
import clientReducer from "./client/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  forgetPassword,
  login,
  profile,
  account,
  Common,
  ticketReducer,
  dashboardReducer,
  clientReducer
});

export default rootReducer;
